import { connect } from 'react-redux';
import React, { useEffect, useState } from "react";
import StateMape from "../../store/stateMap";
import { useFormik } from 'formik';
import "../../sass/form/form.scss";
import api from '../../api';
import { popinfo } from "../Fancybox/Fancybox";
import _ from "lodash";
import update from "immutability-helper"

const DeleteRole = (UserToken, RoleID, InitiativeID) => {
    return new Promise(function(resolve, reject){
        api('/Role', 'delete', {
            RoleID : RoleID
            ,InitiativeID : InitiativeID
        }, 'Bearer ' + UserToken)
            .then(() => {
                resolve();
            })
            .catch((error) => {
                reject(error);
            });
    });
}

const EditRole = (props) => {
    

    const [role, setRole] = useState(props.role);
    const [formDataLoad, setFormDataLoad] = useState(true);

    const settingFormValues = (formData) => {
        _.each(formData, (value, attribute) => {

            if(value === null)
            {
                value = '';
            }

            formik.setFieldValue(attribute, value);

        });
    }

    const formik = useFormik({
        initialValues: {
            RoleID          : role.RoleID
            ,InitiativeID   : role.InitiativeID
            ,RoleName       : ''
            ,RoleDesc       : ''
            ,Gender         : ''
            ,Marital        : ''
            ,AgeMin         : ''
            ,AgeMax         : ''
            ,SortIndex      : ''
            ,IsActive       : ''
            ,RoleBGA        : []
            ,RequiredApproval   : 0
            ,TotalRequired      : 0
            ,SATPoint           : 0
        }
        ,onSubmit: values => {

            var SavingLoader = popinfo('loader', 'Saving Initiative Role', 'Specify your volunteer role to make your initiative more organized');

            api('/Role', 'post', _.assignIn({}, values, {
                
            }), 'Bearer ' + props.auth.token)
                .then(function(response){
                    
                    SavingLoader.close();
                    
                    settingFormValues(response.role);

                    props.onSave(response.role);
                        
                })
                .catch((error) => {
                    popinfo('error', 'Saving Initiative Role', error, {}, SavingLoader);
                });
        }
    });

    useEffect(() => {
        
        if(role && props.auth.user)
        {
            setRole(props.role);
            settingFormValues(role);
            setFormDataLoad(false);
        }

    }, [role, props.auth.user]);

    return (
        <form className="generic-form"  onSubmit={formik.handleSubmit}>
            <div className="form-group">
                <label htmlFor="" className="label">Role Name*</label>
                <div className="description">Name of the role</div>
                {
                    formDataLoad ? <span className="skeleton"></span> :
                    <input type="text" className="form-control text" 
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.RoleName}
                        name="RoleName"
                    />
                }
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">Total Required Person*</label>
                <div className="description">Total of volunteer needed, Keep it 0 to make this position always open</div>
                {
                    formDataLoad ? <span className="skeleton"></span> :
                    <input type="text" className="form-control text" 
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.TotalRequired}
                        name="TotalRequired"
                    />
                }
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">Require Approval*</label>
                <div className="description">Is this role require approval</div>
                {
                    formDataLoad ? <span className="skeleton"></span> :
                    <div className="flex flex-wrap">
                        <label htmlFor="approval-no">
                            <input type="radio" id="approval-no" name="RequiredApproval" checked={formik.values.RequiredApproval == 0} value="0" onChange={(event) => { formik.setFieldValue('RequiredApproval', event.target.value) }} /> No
                        </label>
                        <label htmlFor="approval-yes">
                            <input type="radio" id="approval-yes" name="RequiredApproval" checked={formik.values.RequiredApproval == 1} value="1" onChange={(event) => { formik.setFieldValue('RequiredApproval', event.target.value) }} /> Yes
                        </label>
                    </div>
                }
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">Description</label>
                <div className="description">Describe your detaile role function</div>
                {
                    formDataLoad ? <span className="skeleton"></span> :
                    <textarea type="text" className="form-control textarea" 
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.RoleDesc}
                        name="RoleDesc"/>
                }
            </div>
            <hr/>
            {/* <h2 className='bold'>SAT Point</h2>
            <div className='text-xs leading-text mb-md mt-sm max-w-640'>
                You can provide information about the number of SAT points a student can earn at the end of the initiative if joining this role.
            </div>    
            <div className="form-group">
                <label htmlFor="" className="label">Total Achieveable Point</label>
                <div className="description">The number of SAT points earned for taking this role</div>
                {
                    formDataLoad ? <span className="skeleton"></span> :
                    <input type="text" className="form-control text" 
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.SATPoint}
                        name="SATPoint"
                    />
                }
            </div> */}
            <div className="form-group">
                <label htmlFor="" className="label">BINUS Graduate Attributes*</label>
                <div className="description">Choose the BGA that fits this role</div>
                {
                    <div className="event-bga">
                        {
                            props.config.BGA.map((bga) => (
                                <label key={bga[0]} className="label" name="EventBGA">
                                    <input 
                                        checked={formik.values.RoleBGA.indexOf(bga[0]) > -1}
                                        id="RoleBGA"
                                        type="checkbox" 
                                        value={bga[0]}
                                        onChange={e => {
                                            if(e.target.checked)
                                            {                                                    
                                                if(formik.values.RoleBGA.length == 2)
                                                {
                                                    e.preventDefault();

                                                    return popinfo('error', 'Set BINUS Graduate Attribute', 'Maximal 2 BGA to select');
                                                }
                                                formik.setFieldValue('RoleBGA', 
                                                    update(formik.values.RoleBGA, {$push : [bga[0]] } )
                                                );
                                            }
                                            else
                                            {
                                                let BGAIndex = formik.values.RoleBGA.indexOf(bga[0]);

                                                if(BGAIndex > -1)
                                                {
                                                    formik.setFieldValue('RoleBGA', 
                                                        update(formik.values.RoleBGA, {
                                                            $splice : [[BGAIndex, 1]]
                                                        })
                                                    );
                                                }


                                            }
                                            
                                        }}
                                        onBlur={formik.handleBlur} 
                                    /> <span dangerouslySetInnerHTML={{ __html : bga[1] }}></span>
                                </label>
                            ))
                        }
                    </div>
                }
            </div>
            <div className="" style={{display : 'none'}}>
                <div className="form-group flex-flat">
                    <div>
                        <label htmlFor="" className="label meta-text">Gender</label>
                        {
                            formDataLoad ? <span className="skeleton"></span> :
                            <div >
                                <label htmlFor="gender-male">
                                    <input type="radio" id="gender-male" name="Gender" checked={formik.values.Gender == 'male'} value="male" onChange={(event) => { formik.setFieldValue('Gender', event.target.value) }} /> Male
                                </label>
                                <label htmlFor="gender-female">
                                    <input type="radio" id="gender-female" name="Gender" checked={formik.values.Gender == 'female'} value="female" onChange={(event) => { formik.setFieldValue('Gender', event.target.value) }} /> Female
                                </label>
                                <label htmlFor="gender-any">
                                    <input type="radio" id="gender-any" name="Gender" checked={formik.values.Gender == 'any'} value="any" onChange={(event) => { formik.setFieldValue('Gender', event.target.value) }} /> Any
                                </label>
                            </div>
                        }
                    </div>
                    <div>
                        <label htmlFor="" className="label meta-text">Marital Status</label>
                        {
                            formDataLoad ? <span className="skeleton"></span> :
                            <div >
                                <label htmlFor="marital-male">
                                    <input type="radio" id="marital-male" name="Marital" checked={formik.values.Marital == 'married'} value="married" onChange={(event) => { formik.setFieldValue('Marital', event.target.value) }} /> Married
                                </label>
                                <label htmlFor="marital-female">
                                    <input type="radio" id="marital-female" name="Marital" checked={formik.values.Marital == 'single'} value="single" onChange={(event) => { formik.setFieldValue('Marital', event.target.value) }} /> Single
                                </label>
                                <label htmlFor="marital-any">
                                    <input type="radio" id="marital-any" name="Marital" checked={formik.values.Marital == 'any'} value="any" onChange={(event) => { formik.setFieldValue('Marital', event.target.value) }} /> Any
                                </label>
                            </div>
                        }
                    </div>
                </div>
                <div className="form-group flex-flat">
                    <div>
                        <label htmlFor="" className="label meta-text">Minimal Age</label>
                        {
                            formDataLoad ? <span className="skeleton"></span> :
                            <input type="text" className="form-control text" 
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.AgeMin}
                                name="AgeMin"
                            />
                        }
                    </div>
                    <div>
                        <label htmlFor="" className="label meta-text">Maximal Age</label>
                        {
                            formDataLoad ? <span className="skeleton"></span> :
                            <input type="text" className="form-control text" 
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.AgeMax}
                                name="AgeMax"
                            />
                        }
                    </div>
                </div>         
            </div>
            <hr />
            <div className="text-right">
                <button type="submit" className='btn btn-orange'>Save Role</button>
            </div>
        </form>
    )
}

export {DeleteRole};
export default connect(StateMape)(EditRole);